module.exports = "/fonts/fa-brands-400.woff?b97ac5f935e23fc1816faed5cfcc8244";